import TableCellRenderer from '../../../../table/TableCellRenderer'
import PermissionsCellContent from './PermissionsCellContent'
import $ from 'jquery'

class PermissionsCellRenderer extends TableCellRenderer {
    constructor({
                    editable,
                    generateMoneyReportsEnabled,
                    generateMoneyReportsTitle,
                    isTTAEnabled,
                    onClick,
                    onMouseIn,
                    onMouseOut
                }) {
        super()

        this.params = {
            editable,
            generateMoneyReportsEnabled,
            generateMoneyReportsTitle,
            isTTAEnabled,
            onClick,
            onMouseIn,
            onMouseOut
        }
    }

    generateContent(cell) {
        this.content = new PermissionsCellContent({
            generateMoneyReportsEnabled: this.params.generateMoneyReportsEnabled,
            generateMoneyReportsTooltip: this.params.generateMoneyReportsTitle,
            isTTAEnabled: this.params.isTTAEnabled,
        }).init($(cell.getCellEl()))

        this.updateContent(cell)
    }

    getCellClassName() {
        return ['permissionsCell']
    }

    updateContent(cell) {
        const {
            hasManageUsersRight,
            hasManageOtherTTRight,
            hasGenerateMoneyReportsRight,
            hasManageScopeRight,
        } = cell.getValue()

        this.content.setState({
            canManageUsers: hasManageUsersRight,
            canModifyTime: hasManageOtherTTRight,
            canManageScope: hasManageScopeRight,
            canGenerateMoneyReports: hasGenerateMoneyReportsRight,
        })

        $(cell.getCellEl())
            .on('click', (e) => {this.params.onClick(cell, e)})
            .hover(
                (e) => this.params.onMouseIn(cell, e),
                (e) => this.params.onMouseOut(cell, e)
            )
    }

    setContentState(state) {
        this.content.setState(state)
    }
}

export default PermissionsCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PermissionsCellRenderer.js